import { render } from "./FeaturedProjectsSlide.vue?vue&type=template&id=621cfbfd"
import script from "./FeaturedProjectsSlide.vue?vue&type=script&lang=js"
export * from "./FeaturedProjectsSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__